import React, {Fragment, useEffect, useRef, useState} from 'react'

import {Block} from 'blocks/block'
import {CookieMissing} from 'layout/cookies/cookiemissing'
import {DPIframeblockBlock} from 'types/DPTypes'
import InnerHTML from 'dangerously-set-html-content'
import {Theme} from 'layout/theme'
import css from './iframeblock.module.scss'
import {fromModule} from 'util/styler/Styler'
import {slugify} from 'util/slugify'
import {useIDFromAnchorBlock} from 'util/useAnchor'
import {useTranslation} from 'util/i18'

const styles = fromModule(css)

export const IframeBlock: React.FC<DPIframeblockBlock> = (data) => {
	const dom = useRef<HTMLDivElement>(undefined)
	const [visible, setVisible] = useState(false)
	const id = useIDFromAnchorBlock(data)
	const t = useTranslation()
	const {
		_type,
		title,
		fullwidth,
		ratio_enabled,
		aspectratio,
		embed_code,
		arialabel,
		minwidth,
		hidetext
	} = data

	useEffect(() => {
		setVisible(!minwidth || window.innerWidth > minwidth)
		const resize = () => setVisible(!minwidth || window.innerWidth > minwidth)
		window.addEventListener('resize', resize)

		const clear = []
		const iframes: NodeListOf<HTMLIFrameElement> =
			dom?.current?.querySelectorAll('iframe')

		if (iframes?.length) {
			iframes.forEach((iframe) => {
				if (!iframe) return null
				iframe.setAttribute('loading', 'lazy')
				arialabel && iframe.setAttribute('aria-label', arialabel)
			})
		}

		return () => {
			window.removeEventListener('resize', resize)
			clear.forEach((f) => f())
		}
	}, [minwidth, dom.current])

	if (!embed_code) return null
	if (!visible) {
		return (
			<Block type="iframeblock" anchorID={id} className={styles.iframeblock()}>
				<Theme.Container>
					<p>{hidetext || t.iframe.invisible}</p>
				</Theme.Container>
			</Block>
		)
	}

	const WrapperTag = fullwidth ? Fragment : Theme.Container

	return (
		<Block
			type={_type}
			anchorID={id}
			className={styles.iframeblock.mod({fullwidth})()}
		>
			{title && (
				<Theme.Container>
					<Theme.H2
						id={slugify(title)}
						className={styles.iframeblock.title()}
						mod="blueline"
					>
						{title}
					</Theme.H2>
				</Theme.Container>
			)}
			<WrapperTag>
				<div
					className={styles.iframeblock.iframecontainer.mod(
						(ratio_enabled || aspectratio) && 'aspectratio'
					)()}
					ref={dom}
				>
					<CookieMissing object={embed_code}>
						<InnerHTML html={embed_code} />
					</CookieMissing>
				</div>
			</WrapperTag>
		</Block>
	)
}
